"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubStepCGPTrads = void 0;
exports.ESubStepCGPTrads = {
    draft: "En cours",
    processing: "En cours",
    waiting_signature: "En attente de signature",
    waiting_contrepartie: "En attente de contrepartie",
    waiting_validation: "En cours de traitement",
    validated: "Validées",
    waiting_transfer_sg: "En attente de transfert à la société de gestion",
};
